<div class="flight-detail-item d-flex align-items-center">
  <span>
    <div class="flight-code">
      {{ flight?.departureAirport?.code | numberTranslate }}
    </div>
    <p class="text-nowrap">
      {{
        flight?.plannedDepartureTime
          | flightDate: 'MMM dd' : flight?.plannedDepartureTimeOffset
          | numberTranslate
      }}
    </p>
    <p class="text-nowrap">
      {{
        flight?.plannedDepartureTime
          | flightDate: 'h:mm a' : flight?.plannedDepartureTimeOffset
          | numberTranslate
      }}
    </p>
  </span>
  &nbsp;
  <div [class]="flight?.airlineIconUrl ? 'images-div' : 'div-transform'">
    <div class="airline-icon">
      <img [src]="flight?.airlineIconUrl || null" />
    </div>
    <img [ngClass]="{ flip: dir === 'rtl' }" src="assets/flight.svg" />
    <p class="airline-name">{{ flight?.airlineName }}</p>
  </div>
  &nbsp;
  <span>
    <div class="flight-code">
      {{ flight?.arrivalAirport?.code | numberTranslate }}
    </div>
    <p class="text-nowrap">
      {{
        flight?.plannedArrivalTime
          | flightDate: 'MMM dd' : flight?.plannedArrivalTimeOffset
          | numberTranslate
      }}
    </p>
    <p class="text-nowrap">
      {{
        flight?.plannedArrivalTime
          | flightDate: 'h:mm a' : flight?.plannedArrivalTimeOffset
          | numberTranslate
      }}
    </p>
  </span>
</div>
